import { Modal, Tag, Text } from "@ttc3k/trekker";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Box } from "styled-system/jsx";

type BroadcastModalLayoutProps = PropsWithChildren & {
  isOpen: boolean;
  onClose: () => void;
  isPreview: boolean;
  footerContent?: React.ReactNode;
};

export const BroadcastModalLayout = ({
  isOpen,
  onClose,
  isPreview,
  children,
  footerContent,
}: BroadcastModalLayoutProps) => {
  const { t } = useTranslation("home", {
    keyPrefix: "VIEWS.BROADCAST.VIEW_MODAL",
  });
  return (
    <Modal
      open={isOpen}
      onOpenChange={({ open }: { open: boolean }) => {
        if (!open) onClose();
      }}
      closeTriggerVisual={"light"}
      portal
    >
      <Flex
        flexDir={"column"}
        pt={"6rem"}
        bg={"bg.wa.light"}
        width={"full"}
        minH={"100vh"}
        height={"auto"}
        position={"relative"}
      >
        <Box px={"500"} pb={"500"} flex={"1"}>
          {children}
        </Box>

        {/* Resource navigation footer */}
        {footerContent}

        {/* Preview footer */}
        {isPreview && (
          <Flex
            alignItems={"center"}
            justifyContent={"flex-start"}
            width={"full"}
            py={"250"}
            px={"300"}
            gap={"150"}
            position={"sticky"}
            bottom={"0"}
            zIndex={"10"}
            bg={"bg.success.dark"}
          >
            <Tag visual={"success"} mode={"light"}>
              {t("PREVIEW")}
            </Tag>
            <Text visual={"smallMedium"} color={"white"}>
              {t("PREVIEW_DESCRIPTION")}
            </Text>
          </Flex>
        )}
      </Flex>
    </Modal>
  );
};
